import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 158px);
  gap: 20px;
  padding: 20px 32px 32px;
  font-family: 'Sora', sans-serif;

  @media only screen and (max-width: 768px) {
    padding: 20px;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 158px);
  }

  @media only screen and (max-width: 540px) {
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(6, 158px);
  }
`;
